import {
  SiteConfigMeta,
  SiteConfigSections,
} from "./siteContent";

// 관리자 초기 렌더는 운영 문서가 비어 있어도 기존 공개 shape를 유지하도록 기본값을 맞춘다.
export const defaultSections: SiteConfigSections = {
  youtube: { about_us: { urls: [""] }, videos: { urls: [""] } },
  popup: [
    {
      id: "popup1",
      enabled: true,
      start_at: "",
      end_at: "",
      image_url: "",
      image_storage_path: "",
      image_file: "",
      link_url: "",
      alt: "popup1",
      link_target: "_blank",
      hAlign: "center",
      vAlign: "center",
      offsetX: 240,
      offsetY: 0,
    },
    {
      id: "popup2",
      enabled: true,
      start_at: "",
      end_at: "",
      image_url: "",
      image_storage_path: "",
      image_file: "",
      link_url: "",
      alt: "popup2",
      link_target: "_blank",
      hAlign: "center",
      vAlign: "center",
      offsetX: 0,
      offsetY: 0,
    },
  ],
  ir_ko: {
    title: "",
    published_at: "",
    file_name: "",
    file_url: "",
    file_storage_path: "",
    items: [{ id: "ir-1", name: "IR 1", title: "", published_at: "", file_name: "", file_url: "", file_storage_path: "" }],
  },
  ir_en: {
    title: "",
    published_at: "",
    file_name: "",
    file_url: "",
    file_storage_path: "",
    items: [],
  },
  history: [{ id: "history-1", year: "", contents: [""] }],
};

// 메타 기본값도 탭 공통 형태로 맞춰 두어 화면 분기를 단순하게 만든다.
export const defaultMeta: SiteConfigMeta = {
  youtube: { version: 0, updated_at: "", updated_by: null, updated_by_display: "-", created_at: "" },
  popup: { version: 0, updated_at: "", updated_by: null, updated_by_display: "-", created_at: "" },
  ir_ko: { version: 0, updated_at: "", updated_by: null, updated_by_display: "-", created_at: "" },
  ir_en: { version: 0, updated_at: "", updated_by: null, updated_by_display: "-", created_at: "" },
  history: { version: 0, updated_at: "", updated_by: null, updated_by_display: "-", created_at: "" },
};
